import Solutions from './Solutions.json';

export default {
  Solutions,
};
